export default "__VITE_ASSET__zVSVTKc4__"